import ApiConstant from "../../../constants/api.constants";
import ConsoleType from "../../../constants/console-type.constant";
import Helpers from "../../../utils/helpers";
import api from "../../api";
import surveyOverview from "./stable_data/survey_overview.json";
import surveyEmission from "./stable_data/survery_emission.json";
import surveyDates from "./stable_data/survey_dates.json";
import mapData from "./stable_data/survey_details_map.json";
import KLVData from "./stable_data/klv.json";
import klv from "./stable_data/klv";
import axios from "axios";

//for Survey Overview data
const GetSurveyOverviewData = async (surveyDate: any, siteID: any) => {
  if (surveyDate == undefined) {
    return [];
  }
  return await api
    .get(
      process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA +
        ApiConstant.getSurveyOverview +
        "/" +
        siteID +
        "/" +
        surveyDate
    )
    .then(function (response: any) {
      return response.data;
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, ConsoleType.Error);
    });
  // return await new Promise((resolve, reject) => {
  //   resolve(surveyOverview.data);
  // });
};

//for Emission Overview data
const GetEmissionOverviewData = async (surveyID: any) => {
  // getSurveyOverview
  return await new Promise((resolve, reject) => {
    resolve(surveyEmission.data);
  });
};

//for Survey Dates for the Site
const GetSurveyDatesforSite = async (siteID: any) => {
  return await api
    .get(
      process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA +
        "/api" +
        ApiConstant.getOperationDetailsDates +
        siteID
    )
    .then(function (response: any) {
      return response.data;
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, ConsoleType.Error);
    });
  // return await new Promise((resolve, reject) => {
  //   resolve(surveyDates);
  // });
};

//for Survey Dates for the Site
const GetMapData = async (surveyDate: any, siteID: any) => {
  if (surveyDate == undefined) {
    return [];
  }
  return await api
    .get(
      process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA +
        ApiConstant.getOperationDetails +
        siteID +
        "/" +
        surveyDate
    )
    .then(function (response: any) {
      return response.data.data;
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, ConsoleType.Error);
    });

  // return await new Promise((resolve, reject) => {
  //   resolve(mapData.data);
  // });
};

const GetKLV = async (klv_json_location: any) => {
  return await axios
    .get(process.env.REACT_APP_BLOB_URL + klv_json_location)
    .then((res) => {
      const file = klv_json_location;
      const extension = file.split(".")[1];
      if (extension == "json") {
        return res.data;
      } else if (extension == "txt") {
        return JSON.parse(res.data.Klv_sample());
      } else {
        return res.data;
      }
    });
  // return await new Promise((resolve) => {

  //   resolve(KLVData);
  // });
};

const OperationDetailsService = {
  GetSurveyOverviewData,
  GetEmissionOverviewData,
  GetSurveyDatesforSite,
  GetMapData,
  GetKLV,
};

export default OperationDetailsService;
